import { useState } from 'react';

import { useUserUpdateMutation } from '@/hook';
import { VFlex, VInput, VStack, VTextButton } from '@/package';
import { useAuthStore } from '@/store';
import type { User } from '@/type';

type ChangeNameProps = {
  selectedUser: User;
};

export const ChangeName = ({ selectedUser }: ChangeNameProps) => {
  const [name, setName] = useState(selectedUser?.name ?? '');
  const { mutateAsync: updateUser } = useUserUpdateMutation();

  const handleUserNameChangeButtonClick = () => {
    return updateUser({
      ...selectedUser,
      name,
    }).then(() => useAuthStore.getState().getMe());
  };
  return (
    <VStack key={selectedUser?.name} gap={0.25} className="w-full">
      <VInput
        label="Name"
        value={name}
        onChange={e => setName(e.target.value)}
        fluid
      />

      <VFlex className="w-full" justify="end">
        <VTextButton
          disabled={name === selectedUser?.name}
          size="md"
          onClick={() => handleUserNameChangeButtonClick()}
        >
          Change name
        </VTextButton>
      </VFlex>
    </VStack>
  );
};

ChangeName.displayName = 'ChangeName';
